import { MarketingNarrativesFilterField } from "../types/filters/marketingNarratives";

export interface FilterToCategoryValue {
    displayName: string;
    contentCategoryId?: string;
    categoriesToMap?: FilterToCategoryValue[];
}

export const FilterToCategoriesMapping: {
    [key in any]: FilterToCategoryValue[];
} = {
    [MarketingNarrativesFilterField.MARKETPLACE]: [
        {
            contentCategoryId: "40d2fcef-b6b5-4ae3-bbe9-7b4d637ff702",
            displayName: "US",
        },
        {
            contentCategoryId: "fae80229-abb2-4957-9a0c-110787459eeb",
            displayName: "CA",
        },
        {
            contentCategoryId: "9ac9a83d-ba46-4c72-b4c1-67f5b7c08cee",
            displayName: "MX",
        },
        {
            contentCategoryId: "fbf8756c-6219-489e-ae54-9e4444045970",
            displayName: "UK",
        },
        {
            contentCategoryId: "3795ce64-1518-487f-ad7f-91398b6f9363",
            displayName: "ES",
        },
        {
            contentCategoryId: "9b0a5583-a8de-4a6b-932d-6518973282ef",
            displayName: "DE",
        },
        {
            contentCategoryId: "4502ad0c-378e-4d8e-869a-519d2050ece6",
            displayName: "NL",
        },
        {
            contentCategoryId: "85b15d30-0d5e-4d31-b1f1-1d09c8ea5981",
            displayName: "FR",
        },
        {
            contentCategoryId: "b092fd43-c2cd-4598-bf77-630892d42efd",
            displayName: "IT",
        },
        {
            contentCategoryId: "596799fe-0f02-469c-96a9-9ea038ee35db",
            displayName: "PL",
        },
        {
            contentCategoryId: "81dc2058-736d-4874-bea4-a98dfdf311d4",
            displayName: "SE",
        },
        {
            contentCategoryId: "5323b0a6-f5a4-4fb7-a581-91bfe5e0584a",
            displayName: "CZ",
        },
        {
            contentCategoryId: "b526ec13-2cde-47b9-bd7f-89e81db7ab33",
            displayName: "LUX",
        },
        {
            contentCategoryId: "6749c4a9-1448-4887-95d2-d880e846ec94",
            displayName: "AU",
        },
        {
            contentCategoryId: "2ce653e0-c60b-4eb2-80d1-65be00a9067a",
            displayName: "JP",
        },
        {
            contentCategoryId: "175aee2a-31f9-4f80-a23c-0cebfee7643e",
            displayName: "CN",
        },
        {
            contentCategoryId: "01b8c46d-7ec8-4c1f-b203-0484076841b3",
            displayName: "KR",
        },
        {
            contentCategoryId: "fa2a89ac-ed88-451d-b597-983b1d0a1a83",
            displayName: "IN",
        },
        {
            contentCategoryId: "efee5b1b-d1a5-49b4-828c-e08b3aa638a6",
            displayName: "TW",
        },
        {
            contentCategoryId: "5f931bf9-b7db-4746-bc9b-07262b7d545f",
            displayName: "SG",
        },
        {
            contentCategoryId: "b36c7e86-497e-4ca6-a400-fecd938adde7",
            displayName: "BR",
        },

        {
            contentCategoryId: "b7be897d-b138-4414-9fb4-c797d8ef0938",
            displayName: "AE",
        },
        {
            contentCategoryId: "c3a69cd5-9d1f-4f7a-b600-17df2132daa7",
            displayName: "TR",
        },
        {
            contentCategoryId: "4aa87068-4282-4659-adec-64599279676e",
            displayName: "IL",
        },
        {
            contentCategoryId: "0d7c8fb7-bb3c-4b5a-af46-8ca9e8538a84",
            displayName: "EG",
        },
        {
            contentCategoryId: "51de98fa-9eed-45d7-8771-c85aa756fba1",
            displayName: "KSA",
        },
        {
            contentCategoryId: "d15c9a2e-7363-43c6-9324-93aa2b1df466",
            displayName: "Worldwide",
        },
    ],
    [MarketingNarrativesFilterField.LANGUAGE]: [
        {
            contentCategoryId: "0276c874-0621-4648-a41b-04f1cbfe31be",
            displayName: "EN",
        },
        {
            contentCategoryId: "39eed39f-a3e0-4f24-8735-99df001c3bbc",
            displayName: "ES",
        },
        {
            contentCategoryId: "22b67b67-026e-4826-b56b-8513762ad27b",
            displayName: "DE",
        },
        {
            contentCategoryId: "1e19dc55-4944-40a5-b0bf-e9438c9713af",
            displayName: "NL",
        },
        {
            contentCategoryId: "2bfc679f-81b8-4f95-8399-e4428594223d",
            displayName: "FR",
        },
        {
            contentCategoryId: "68e21a12-03cc-42ee-8784-5a31f0553feb",
            displayName: "IT",
        },
        {
            contentCategoryId: "4daefdb9-a04c-4d60-97a2-cab0f30c5cc8",
            displayName: "PL",
        },
        {
            contentCategoryId: "d734f8c0-b335-4370-9cf8-2dc616ee776d",
            displayName: "PT",
        },
        {
            contentCategoryId: "4dbb1197-cb11-4e0a-aff3-8ed85e2eeb27",
            displayName: "SV",
        },
        {
            contentCategoryId: "102cd0a9-d10a-476d-857a-1e041535bee5",
            displayName: "JP",
        },
        {
            contentCategoryId: "dc0e3cad-7937-4d9a-8239-0ab2d8e181d0",
            displayName: "ZH",
        },
        {
            contentCategoryId: "d385f584-ce92-4ccd-9aa4-f22735c3a978",
            displayName: "KO",
        },
        {
            contentCategoryId: "45ee6cf6-c8b4-4fba-a7be-998b7d0a5fe8",
            displayName: "AR",
        },
        {
            contentCategoryId: "6a666109-7e0c-4bbe-b211-cdfd2dc1b6cb",
            displayName: "TR",
        },
        {
            contentCategoryId: "40e5a8b9-5f80-4d6a-bdef-cd248a2f06ba",
            displayName: "HE",
        },
        {
            contentCategoryId: "07f29098-e2e6-4ebe-bf79-951e381d80b2",
            displayName: "CS",
        },
        {
            contentCategoryId: "8b25d615-d7e2-4895-8d11-952a89047a2f",
            displayName: "HI",
        },
        {
            contentCategoryId: "180443a7-dcb1-4326-aef0-8e991318a7a1",
            displayName: "TH",
        },
    ],
    [MarketingNarrativesFilterField.AD_PRODUCTS_AND_FORMATS]: [
        {
            contentCategoryId: "49a4aaa2-7a17-4aba-91b0-5ec1cf37c1df",
            displayName: "Display Ads",
        },
        {
            contentCategoryId: "89936a2c-91ea-47c3-aa09-3c7a41ed4ea2",
            displayName: "Audio Ads",
        },
        {
            contentCategoryId: "3f3255d4-413d-4abe-9ce6-801b4026bbb0",
            displayName: "Out-of-home",
        },
        {
            contentCategoryId: "fadd4cbc-7341-44ac-b318-4c9126a02045",
            displayName: "Sponsorships",
        },
        {
            contentCategoryId: "7a6a404c-bbe8-4cd7-b5e5-0d9c9e7fddd9",
            displayName: "Custom Ads",
        },
        {
            contentCategoryId: "ab46a054-acf6-40d5-98a7-1d7b8e625b07",
            displayName: "On Box",
        },
        {
            contentCategoryId: "415e102f-40ba-45f4-b780-aebb3da9b440",
            displayName: "Sponsored Products",
        },
        {
            contentCategoryId: "d17af4f0-3e79-4425-9e90-8e3e522f7fd1",
            displayName: "Sponsored Brands",
        },
        {
            contentCategoryId: "d0c54ecb-781b-4f31-baf8-c96851aa3713",
            displayName: "Sponsored Display",
        },
        {
            contentCategoryId: "d2ece81b-0b4a-4b9a-9481-88968e695101",
            displayName: "Sponsored TV",
        },
        {
            contentCategoryId: "25c37565-d014-41d3-8618-0e27ccb0c551",
            displayName: "All Sponsored Ads",
        },
        {
            contentCategoryId: "f5c1b145-fc0b-4c67-b224-4a5d75963387",
            displayName: "Stores",
        },
        {
            contentCategoryId: "7b220894-0235-4f33-a6f1-a19cdef77930",
            displayName: "Posts",
        },
        {
            contentCategoryId: "0dcee891-0896-471d-991c-d8e0405955b9",
            displayName: "Brand Follow",
        },
        {
            contentCategoryId: "f9fc45ce-b8f3-4c14-8d8e-6bfaf2b21252",
            displayName: "Amazon Live",
        },
        {
            contentCategoryId: "252dba6f-6f94-4057-b580-ac7fa9ea7eb3",
            displayName: "Streaming TV Ads",
        },
        {
            contentCategoryId: "244b1450-be5c-4b97-a507-1b98230cc396",
            displayName: "Online Video",
        },
        {
            contentCategoryId: "1fb105bb-70b9-4354-a2d5-194216d90135",
            displayName: "Amazon DSP",
        },
        {
            contentCategoryId: "dd2edc5f-cccc-4b4a-8784-20b7ed6522b7",
            displayName: "Amazon Publisher Direct",
        },
        {
            contentCategoryId: "a98f2db7-d572-46ac-b8b1-b99459675973",
            displayName: "Video Creative Builder",
        },
        {
            contentCategoryId: "acdd70c0-471c-4fea-9603-47788ca06b0c",
            displayName: "Amazon Ad Server",
        },
        {
            contentCategoryId: "3558c43b-0d17-4a40-9a8f-eef5344650df",
            displayName: "Amazon Ads API",
        },
    ],
    [MarketingNarrativesFilterField.AD_ACTIVATION_CHANNEL]: [
        {
            displayName: "Amazon Ads",
            categoriesToMap: [
                {
                    displayName: "Amazon Ads",
                    contentCategoryId: "3e46dcb8-e2d7-462c-b10b-6bdb07fe66ff",
                },
                {
                    contentCategoryId: "604958d2-00ce-4075-9f17-5442c9fcfb38",
                    displayName: "Amazon Ads",
                },
            ],
        },
        {
            contentCategoryId: "dd2edc5f-cccc-4b4a-8784-20b7ed6522b7",
            displayName: "Amazon Publisher Direct",
        },
        {
            contentCategoryId: "07de4c5a-8d12-4fdb-b7db-6f72e361638f",
            displayName: "AWS",
        },
        {
            contentCategoryId: "22a0c658-168d-49e8-81aa-a0ef29775811",
            displayName: "Amazon Business",
        },
        {
            contentCategoryId: "6814661f-e05b-45be-92d4-dea1e1cbc7e2",
            displayName: "Amazon Fresh",
        },
        {
            contentCategoryId: "c2b35ab3-cb61-4746-905e-5f21fbf106dc",
            displayName: "Whole Foods",
        },
        {
            contentCategoryId: "1b924138-b8e9-4c1a-9115-c3667f35c3b4",
            displayName: "Fire TV",
        },
        {
            contentCategoryId: "3c1871ad-d181-490b-8f1b-743e32b75bed",
            displayName: "Fire Tablet",
        },
        {
            contentCategoryId: "4262f028-968f-4973-94b9-c45cc2bde7b5",
            displayName: "Alexa",
        },
        {
            contentCategoryId: "7ad20590-9960-42ea-98c3-ff977080b707",
            displayName: "Echo",
        },
        {
            contentCategoryId: "811f2318-96dc-462b-a3af-bdde61048c45",
            displayName: "Prime Video",
        },
        {
            contentCategoryId: "ad6ec150-fa25-48c4-889e-7f5875083d1e",
            displayName: "Twitch",
        },
        {
            contentCategoryId: "1a38e4b8-f452-4e2a-badf-940cf0cb9d53",
            displayName: "Freevee",
        },
        {
            contentCategoryId: "ce1b8ecb-b8ec-4e31-b06b-553584891fc5",
            displayName: "IMDb",
        },
        {
            contentCategoryId: "f5fe2e43-b14e-4419-8394-9b1e18394c36",
            displayName: "Live Sports",
        },
        {
            contentCategoryId: "144d3594-eb1c-4df3-92d5-d0802b8a9bf8",
            displayName: "Amazon Music",
        },
    ],
    [MarketingNarrativesFilterField.MARKETING_STRATEGY]: [
        {
            contentCategoryId: "19136a09-b992-407c-a8c7-1c374116b6f0",
            displayName: "Multi-objective Strategy",
        },
        {
            contentCategoryId: "e03c6248-c20f-4da0-b9ea-68b106317291",
            displayName: "Branding",
        },
        {
            contentCategoryId: "05725917-3c01-45c3-bc59-63477c4c23f4",
            displayName: "Always On",
        },
        {
            contentCategoryId: "73bc1750-f782-485c-82d9-50faf8805e43",
            displayName: "Customer Journey",
        },
        {
            contentCategoryId: "b70ad94b-5c87-41fa-82a6-64696c2d3912",
            displayName: "Better Together",
        },
        {
            contentCategoryId: "1e224f43-ae9e-48a5-8ccb-9f38f1abfa9d",
            displayName: "Cross Sell",
        },
    ],
    [MarketingNarrativesFilterField.SEASONAL_EVENTS]: [
        {
            contentCategoryId: "dbc32387-7e81-4425-9383-ac0d6244eee0",
            displayName: "Prime Day",
        },
        {
            contentCategoryId: "71971bcc-c56d-47af-bad1-44242ab915c5",
            displayName: "Back To School",
        },
        {
            contentCategoryId: "451d05f8-867b-438c-9da1-c41f3722fd52",
            displayName: "BFCM",
        },
        {
            contentCategoryId: "565b7f8c-efe1-4b8a-b31f-699730bccfc0",
            displayName: "Holiday",
        },
        {
            contentCategoryId: "fc551083-9373-405b-94e0-8c1d3eb463db",
            displayName: "TNF",
        },
        {
            contentCategoryId: "4cec4b5d-2312-497c-94f7-f8f38fa45c22",
            displayName: "Climate Pledge",
        },
        {
            contentCategoryId: "376fc793-5aed-4abc-b816-a3bcae588366",
            displayName: "Mother's Day",
        },
        {
            contentCategoryId: "740a1cfa-7341-4564-ae9b-0bc097406348",
            displayName: "Father's Day",
        },
        {
            contentCategoryId: "188e9b50-8b64-4fc9-95fc-056b3e5f3b34",
            displayName: "Easter",
        },
    ],
    [MarketingNarrativesFilterField.ADVERTISER_GOAL]: [
        {
            contentCategoryId: "b67ad4dd-6148-45af-8f89-f64391ba2a8a",
            displayName: "Awareness",
            categoriesToMap: [
                {
                    contentCategoryId: "1b633390-21c3-4dde-88b3-aabeb967e6d8",
                    displayName: "Reach more customers",
                },
                {
                    contentCategoryId: "c493d6a9-c079-4458-a3fd-4d8377c89cf2",
                    displayName: "Build brand awareness",
                },
            ],
        },
        {
            displayName: "Consideration",
            categoriesToMap: [
                {
                    contentCategoryId: "706bea03-ec1c-45a0-9941-59f845ccd6bd",
                    displayName: "Drive traffic",
                },
            ],
        },
        {
            displayName: "Conversion",
            categoriesToMap: [
                {
                    contentCategoryId: "5f01cee4-0853-435c-976f-8ee0d559bfd4",
                    displayName: "Increase sales and conversion",
                },
            ],
        },
        {
            displayName: "Loyalty",
            categoriesToMap: [
                {
                    contentCategoryId: "037114de-5ef2-4fb7-b79b-3dad85f19b70",
                    displayName: "Improve customers loyalty",
                },
            ],
        },
        {
            contentCategoryId: "d5758012-b225-4403-a272-163b438fe6eb",
            displayName: "BGF",
        },
    ],
    [MarketingNarrativesFilterField.PRIMARY_CONTENT_CREATOR_TEAM]: [
        {
            displayName: "US CPG & Grocery",
            contentCategoryId: "04ffa177-dd98-4c13-918e-e0ea68b4372d",
        },
        {
            displayName: "US Hardlines & Softlines",
            contentCategoryId: "61f1d0a9-9f13-4a34-b7a6-cb80bbe98409",
        },
        {
            displayName: "US Non-Endemic",
            contentCategoryId: "c3845399-f13c-465b-9930-94067a29b934",
        },
        {
            displayName: "IX - LATAM",
            contentCategoryId: "4fa78e95-05fe-4b18-b679-febbaeac485a",
        },
        {
            displayName: "IX - EMEA",
            contentCategoryId: "6cc40c79-20d2-42ec-8259-00f363039221",
        },
        {
            displayName: "IX - USS",
            contentCategoryId: "7d6f0217-d94e-4afc-a3a8-48b098ec68e4",
        },
        {
            displayName: "IX - APAC",
            contentCategoryId: "f3d4c313-99f7-4817-8591-180795a7b9c0",
        },
        {
            displayName: "JP",
            contentCategoryId: "0a91a2dc-b604-4b82-aa5c-a71eb40feba2",
        },
        {
            displayName: "CN - Seller",
            contentCategoryId: "cae4a40b-8b55-48ae-ba15-e897e75d29a7",
        },
        {
            displayName: "INTL - CA",
            contentCategoryId: "7724d737-86d9-4dcb-a1d6-df8c4055620e",
        },
        {
            displayName: "INTL - EU5",
            contentCategoryId: "b92c3e22-7fd8-4558-8cf1-b3ed07255b44",
        },
        {
            displayName: "Global Insights Accelerator",
            contentCategoryId: "2cffe08f-0154-4888-a07e-54e91a6c04e3",
        },
        {
            displayName: "Global Analytics Advisory",
            contentCategoryId: "8e29110e-4dd1-40fd-97f7-12b102b1bb50",
        },
        {
            displayName: "AdEx",
            contentCategoryId: "4b851755-4576-4b50-a332-cb61d6e60db4",
        },
        {
            displayName: "Agency",
            contentCategoryId: "fb398dab-72e6-4a7f-8502-3bbee937d050",
        },
        {
            displayName: "Focal Point",
            contentCategoryId: "2720f261-df66-4682-a5de-d3945bf405e2",
        },
        {
            displayName: "Global Accounts",
            contentCategoryId: "4154ef15-66fe-4ed1-9b22-cacd9a99bbc1",
        },
        {
            displayName: "Measurement",
            contentCategoryId: "9e0286b0-db4f-4e22-a120-d8d5e1bcb745",
        },
        {
            displayName: "Industry & Integrated Marketing",
            contentCategoryId: "cf953675-bedc-4f29-a175-f2e76a664b9d",
        },
        {
            displayName: "Brand Marketing",
            contentCategoryId: "ddc42e9c-5003-42a7-aab1-a91db1fe078a",
        },
        {
            displayName: "APAC Marketing",
            contentCategoryId: "5c1a77c8-a211-4b34-ab41-55d3b7807b14",
        },
        {
            displayName: "SMB Marketing",
            contentCategoryId: "27495b34-f2c6-4321-8479-b60064e8ffff",
        },
        {
            displayName: "Regional Marketing",
            contentCategoryId: "48e6ca55-c801-46a9-b036-d7758b8c865b",
        },
        {
            displayName: "Product Marketing",
            contentCategoryId: "9521e703-8d66-4022-a54a-270d1d99dab7",
        },
        {
            displayName: "Global Training & Education",
            contentCategoryId: "ebc7344c-6205-428f-9f70-bfeb771d8ac5",
        },
        {
            displayName: "Measurement Success - Live Sports",
            contentCategoryId: "b1ec699f-2a92-4712-bd8a-597bc884aaac",
        },
        {
            displayName: "Measurement Success - Non Sports",
            contentCategoryId: "cb1c9486-d9c3-4d26-a1a7-9681ce262a5e",
        },
    ],
    [MarketingNarrativesFilterField.VERTICAL]: [
        {
            displayName: "Automotive",
            contentCategoryId: "06aba83d-64f5-4624-8da4-c8fd3d58bfe6",
        },
        {
            displayName: "Consumer Packaged Goods",
            categoriesToMap: [
                {
                    displayName: "CPG",
                    contentCategoryId: "e0c52ada-37ed-4f84-9cf1-1e65c855d876",
                },
                {
                    displayName: "Beauty",
                    contentCategoryId: "55b9505f-4b21-4731-82ab-ca27674fdbe3",
                },
                {
                    displayName: "Health, Household, and Baby",
                    contentCategoryId: "f4820594-aecd-4885-927e-3051a25e71b6",
                },
                {
                    displayName: "Grocery",
                    contentCategoryId: "b22e4adc-9b6b-42ff-a3b3-4e8526b34fc1",
                },
            ],
        },
        {
            displayName: "Entertainment and Media",
            categoriesToMap: [
                {
                    displayName: "Entertainment",
                    contentCategoryId: "73512d94-3495-48ae-8bd4-8b0abe68c41f",
                },
                {
                    displayName: "TV - Streaming",
                    contentCategoryId: "bc78ab26-18a6-456d-80d2-ab2ae58bd16d",
                },
                {
                    displayName: "Theatrical",
                    contentCategoryId: "cf57e8f2-26e7-4634-a9fa-39d3bcb68296",
                },
                {
                    displayName: "Toys",
                    contentCategoryId: "0faaccad-90a0-4c3d-9fbc-64851f7a9de8",
                },
            ],
        },
        {
            displayName: "Financial Services",
            contentCategoryId: "12bc3ed6-fb9f-44eb-b3bf-837db6bfb6e2",
        },
        {
            displayName: "Hardlines",
            categoriesToMap: [
                {
                    displayName: "Consumer Electronics",
                    contentCategoryId: "fbf74fb5-8851-4c2c-882a-ca94a64051b8",
                },
                {
                    displayName: "Video Games",
                    contentCategoryId: "2d97b2e7-d256-4ea4-9452-5f1e645d09f9",
                },
                {
                    displayName: "Office Supplies",
                    contentCategoryId: "340b86ab-477a-4942-9599-7cfd43a771b8",
                },
                {
                    displayName: "Home Goods",
                    contentCategoryId: "cf3fb480-42e5-4ef4-9d4d-b02e63d7d86c",
                },
                {
                    displayName: "Home Improvement and Recreation",
                    contentCategoryId: "f13526e3-66a5-4cdd-8dff-94428bd2abfd",
                },
            ],
        },
        {
            displayName: "Travel",
            categoriesToMap: [
                {
                    displayName: "Travel",
                    contentCategoryId: "e16ff233-69e4-4065-9c27-8764a10609d4",
                },
                {
                    displayName: "Hospitality",
                    contentCategoryId: "017d5096-1a58-4b27-ad1d-0df6347c740c",
                },
            ],
        },
        {
            displayName: "Retailer",
            categoriesToMap: [
                {
                    displayName: "3P Retail",
                    contentCategoryId: "08f6a42c-4ead-4284-bed5-4af74c61c96b",
                },
                {
                    displayName: "Quick Serve Restaurants",
                    contentCategoryId: "28d73cd6-6d51-486c-a2cd-1f94a4ca9d86",
                },
            ],
        },
        {
            displayName: "Softlines",
            contentCategoryId: "1e2fa606-7258-432c-be47-27a2c494eb57",
        },
        {
            displayName: "Telco",
            contentCategoryId: "785eda3e-8243-4e4b-acb2-61b200b15258",
        },
        {
            displayName: "Other",
            contentCategoryId: "017d5096-1a58-4b27-ad1d-0df6347c740c",
        },
        {
            displayName: "All Non-Endemic",
            contentCategoryId: "eb2d29fe-d5b2-4126-8269-61bb51061834",
        },
        {
            displayName: "All Endemic",
            contentCategoryId: "43de4580-0054-4b95-91f2-59d6413095c0",
        },
        {
            displayName: "Agency",
            contentCategoryId: "2caf589c-ee58-4825-a7d8-bdd8c4bb411f",
        },
    ],
    [MarketingNarrativesFilterField.SUBVERTICAL]: [
        {
            contentCategoryId: "48b5866c-e0c9-4cc2-a831-ccf6516d71c5",
            displayName: "Baby Consumables",
        },
        {
            contentCategoryId: "e3f650e8-376c-49ab-871b-86714697e2b7",
            displayName: "Beauty",
        },
        {
            displayName: "Grocery - Food",
            contentCategoryId: "8b27219b-9586-46b1-978c-37d8e8f78521",
        },
        {
            contentCategoryId: "3cfd5276-5b08-4af7-8748-b6e64afa0c41",
            displayName: "Grocery - Beverage",
        },
        {
            contentCategoryId: "ec078675-1ae8-4e33-b756-81177c080c49",
            displayName: "Health and Personal Care",
        },
        {
            contentCategoryId: "4461ac12-9cd6-4ee5-9087-6bda50ab9164",
            displayName: "Pet Consumables",
        },
        {
            contentCategoryId: "dff4120d-6612-4d04-9b18-ab3c2d654ee2",
            displayName: "Pharma",
        },
        {
            contentCategoryId: "dff4120d-6612-4d04-9b18-ab3c2d654ee2",
            displayName: "Healthcare",
        },
        {
            contentCategoryId: "3fede36b-2213-4724-8507-f361b68b9096",
            displayName: "Apps",
        },
        {
            contentCategoryId: "3fede36b-2213-4724-8507-f361b68b9096",
            displayName: "Streaming Media",
        },
        {
            contentCategoryId: "ad245b07-7ab1-4664-be89-2a7b130198d6",
            displayName: "Gaming",
        },
        {
            contentCategoryId: "aafb2add-42a6-496f-b52e-a642da12b401",
            displayName: "Brokerage",
        },
        {
            contentCategoryId: "aafb2add-42a6-496f-b52e-a642da12b401",
            displayName: "Insurance",
        },
        {
            contentCategoryId: "48b5866c-e0c9-4cc2-a831-ccf6516d71c5",
            displayName: "Baby Gear",
        },
        {
            contentCategoryId: "3fede36b-2213-4724-8507-f361b68b9096",
            displayName: "PC Hardware",
        },
        {
            contentCategoryId: "8f053ee0-e213-4b8e-b816-4c6848ed2568",
            displayName: "Home and Furniture",
        },
        {
            contentCategoryId: "8c4585f2-e934-439b-ba3e-477882f7fc06",
            displayName: "Home and Garden - Outdoor",
        },
        {
            contentCategoryId: "cc856852-1043-4a52-abaa-e408d657ffb6",
            displayName: "Kitchen",
        },
        {
            contentCategoryId: "8ae5794f-a432-4c78-bb0b-e2fef82bf0e8",
            displayName: "Office Products",
        },
        {
            contentCategoryId: "553373dd-3065-48cd-9ef8-24b02004d879",
            displayName: "Sporting Goods",
        },
        {
            contentCategoryId: "4461ac12-9cd6-4ee5-9087-6bda50ab9164",
            displayName: "Pet Gear",
        },
        {
            contentCategoryId: "5be2f0f6-a33e-4db5-9b4f-0948a59a2b07",
            displayName: "Tools and Home Improvement",
        },
        {
            contentCategoryId: "507af70d-2e31-4c42-ab8c-48da025e3dd5",
            displayName: "Toys",
        },
        {
            contentCategoryId: "ad245b07-7ab1-4664-be89-2a7b130198d6",
            displayName: "Video Games",
        },
        {
            contentCategoryId: "373bf59f-df95-4db0-ad15-1ab22bbe1b47",
            displayName: "Training and Education",
        },
        {
            contentCategoryId: "373bf59f-df95-4db0-ad15-1ab22bbe1b47",
            displayName: "Author",
        },
        {
            contentCategoryId: "373bf59f-df95-4db0-ad15-1ab22bbe1b47",
            displayName: "Periodical",
        },
        {
            contentCategoryId: "373bf59f-df95-4db0-ad15-1ab22bbe1b47",
            displayName: "Publisher",
        },
        {
            contentCategoryId: "e3f650e8-376c-49ab-871b-86714697e2b7",
            displayName: "Fashion & Beauty Retailer",
        },
        {
            contentCategoryId: "c75dcfb7-9256-4018-9010-bdcf58fdf341",
            displayName: "Luxury Retailer",
        },
        {
            contentCategoryId: "7d5d2ca6-8d18-4d13-a015-f6ec7351bc69",
            displayName: "Restaurants",
        },
        {
            contentCategoryId: "e30145b6-60f9-4665-982c-adf320ba063d",
            displayName: "Apparel",
        },
        {
            contentCategoryId: "e30145b6-60f9-4665-982c-adf320ba063d",
            displayName: "Sportswear",
        },
        {
            contentCategoryId: "c75dcfb7-9256-4018-9010-bdcf58fdf341",
            displayName: "Luxury",
        },
        {
            contentCategoryId: "9b9de50f-a7b1-4816-9a7c-3c14f4d359b9",
            displayName: "Jewelry",
        },
        {
            contentCategoryId: "df98555f-4786-4bca-a57e-947bfedfde2a",
            displayName: "Watches",
        },
    ],
    [MarketingNarrativesFilterField.FILE_TYPE]: [
        {
            displayName: "PDF",
            contentCategoryId: ".pdf",
        },
        {
            displayName: "Powerpoint",
            contentCategoryId: ".pptx",
        },
        {
            displayName: "Excel",
            contentCategoryId: ".xlsx",
        },
        {
            displayName: "Word",
            contentCategoryId: ".docx",
        },
        {
            displayName: "Image",
            contentCategoryId: ".png|.jpg",
        },
        {
            displayName: "Video",
            contentCategoryId: ".mp4",
        },
    ],
};

export const VerticalToSubVerticalMap: { [key: string]: string[] } = {
    Automotive: [],
    "Consumer Packaged Goods": [
        "Baby Consumables",
        "Beauty",
        "Grocery - Food",
        "Grocery - Beverage",
        "Health and Personal Care",
        "Pet Consumables",
        "Pharma",
    ],
    "Entertainment and Media": [
        "Apps",
        "Streaming Media",
        "Gaming",
        "Video Games",
        "Toys",
    ],
    "Financial Services": ["Insurance", "Brokerage"],
    Hardlines: [
        "Home and Furniture",
        "Home and Garden - Outdoor",
        "Kitchen",
        "Office Products",
        "PC Hardware",
        "Pet Gear",
        "Sporting Goods",
        "Tools and Home Improvement",
        "Toys",
        "Video Games",
    ],
    Travel: [],
    Retailer: ["Fashion & Beauty Retailer", "Luxury Retailer", "Restaurants"],
    Softlines: ["Apparel", "Jewelry", "Luxury", "Watches"],
    Telco: [],
    Other: [],
};
